import React from "react";
import { Link } from "react-router-dom";
import "../styles/SignedOutView.css";

const SignedOutView: React.FC = () => {
  return (
    <div className="signed-out-container">
      <img
        src="/images/fiksukaappi_logo.png"
        alt="FiksuKaappi logo"
        className="signedout-logo"
      />

      <h2>Olet kirjautunut ulos</h2>
      <p>Kiitos käynnistä! Tervetuloa takaisin milloin vain.</p>

      <div className="signed-out-buttons">
        <Link to="/">Palaa etusivulle ilman kirjautumista</Link>
      </div>
    </div>
  );
};

export default SignedOutView;
